import { prepHandleEvent } from "./prepHandleEvent";
import { EventToCanvas } from "./EventToCanvas";
import { Globals } from "../CoreApp/Globals";
import { enumChartElement, enumUIModes, enumWSInteractMode } from "../constants";

const kClickToolbarModes = [enumUIModes.chart, enumUIModes.planning, enumUIModes.edit];

export function GetToolbarTargetBox(canvasPanel) {
  if (canvasPanel.GetNumSelectedElements() !== 1) return null;

  const box = canvasPanel.GetFirstSelectedBox(false);
  if (box) return box;

  const cell = canvasPanel.GetFirstSelectedElement(enumChartElement.boxCell);
  return cell?.GetParentBox() ?? null;
}

export function ShowChartBoxToolbar(canvasPanel) {
  if (!kClickToolbarModes.includes(Globals._uiConfig.GetUIMode())) return;
  // Parity with QPlanInteractPanel.ShouldShow: no box actions inside publish preview.
  if (Globals._publishRef) return;

  canvasPanel.HandleReactClickPad(GetToolbarTargetBox(canvasPanel));
}

export function maybeShowChartBoxClickToolbar(myApp, preInteractMode) {
  if (preInteractMode !== enumWSInteractMode.standardMode) return;

  const canvasPanel = myApp.fWSMgr?.fCanvasPanel;
  if (canvasPanel) ShowChartBoxToolbar(canvasPanel);
}

export function handleMouseUp(canvas) {
  return function (event) {
    var rect = canvas.getBoundingClientRect();
    var p = EventToCanvas(event, rect.left, rect.top);

    var myApp = prepHandleEvent(this, false, null, null);
    if (myApp == null) return;

    var preInteractMode = myApp.fWSMgr?.fInteractMode;
    myApp.HandleMouseUp(p.x, p.y, event, canvas);

    if (event.button === 0 && event.target === canvas && canvas.id === "basecanvas") {
      maybeShowChartBoxClickToolbar(myApp, preInteractMode);
    }
  };
}
